import { FormTextCollection } from './FormTextCollection'

export const FormTextCollectionPdf = props => {
  return <FormTextCollection {...props} pdf />
}
